var render, staticRenderFns
import script from "./FrontageLink.vue?vue&type=script&lang=js"
export * from "./FrontageLink.vue?vue&type=script&lang=js"
import style0 from "./FrontageLink.vue?vue&type=style&index=0&id=76f5cece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f5cece",
  null
  
)

export default component.exports